<template>
  <div>
    <Header class="head" :height="40" :title="stockName+ '两融明细'"/>
    <div class="wrap">
      <div class="list-container">
        <div class="head">
          <div class="xv-symbol">
            <div style="color:#999">日期</div>
          </div>
          <div ref="headnoscroll" class="headnoscroll">
            <div class="align-left" style="width:0.75rem;">收盘价</div>
            <div class="align-left" style="width:0.75rem;">涨跌幅</div>
            <div class="buy align-left">融资买入额</div>
            <div class="rzche align-left">融资偿还额</div>
            <div class="rzjme align-left">融资净买额</div>
            <div class="rzye align-left">融资余额</div>
            <div class="rzyezlb align-left">融资余额占流比</div>
            <div class="rzmcl align-left">融券卖出量</div>
            <div class="rzchl align-left">融券偿还量</div>
            <div class="rzjml align-left">融券净卖量</div>
            <div class="rqyl align-left">融券余量</div>
            <div class="rqye align-left">融券余额</div>
            <div class="lrye align-left">两融余额</div>
            <div class="lryecz align-left">两融余额差值</div>
          </div>
        </div>
        <div class="list">
          <div class="headList">
            <div class="headItem" v-for="(v, k) in dateList" :key="k">
              <div class="xv-symbol symbol-item">
                {{v}}
              </div>
            </div>
          </div>
          <div>
          <div ref="datalist" class="dataList" @scroll="connectHeadScroll">
            <div class="dataItem" v-for="(v, k) in list" :key="k">
              <div class="j align-left" :class="{'red': v.UpDownRatio > 0, 'green': v.UpDownRatio < 0, 'black': v.UpDownRatio == 0}">{{v.ClosePrice.toFixed(2)}}</div>
              <div class="zf align-left" :class="{'red': v.UpDownRatio > 0, 'green': v.UpDownRatio < 0, 'black': v.UpDownRatio == 0}">{{ (v.UpDownRatio*100).toFixed(2) + '%' }}</div>
              <div class="buy align-left money">
                {{ formatUnit(v.FinanceBuyValue) }}
              </div>
              <div class="rzche align-left money">{{ formatUnit(v.FinanceRefundValue) }}</div>
              <div class="rzjme align-left money" :class="{'red':v.FinancePureValue > 0, 'green': v.FinancePureValue < 0}">{{ formatUnit(v.FinancePureValue) }}</div>
              <div class="rzye align-left money">{{ formatUnit(v.FinanceValue) }}</div>
              <div class="rzyezlb align-left money">{{ (v.FinaInTotalRatio*100).toFixed(2) + '%' }}</div>
              <div class="rzmcl align-left money">{{ formatUnit(v.SecuritySellVolume) }}</div>
              <div class="rzchl align-left money">{{ formatUnit(v.SecurityRefundVolume) }}</div>
              <div class="rzjml align-left money" :class="{'red':v.SecurityPureValue > 0, 'green': v.SecurityPureValue < 0}">{{ formatUnit(v.SecurityPureValue) }}</div>
              <div class="rqyl align-left money">{{ formatUnit(v.SecurityVolume) }}</div>
              <div class="rqye align-left money">{{ formatUnit(v.SecurityValue) }}</div>
              <div class="lrye align-left money">{{ formatUnit(v.FinanceSecurityValue) }}</div>
              <div class="lryecz align-left money">{{ formatUnit(v.FinanceSecurityDiffValue) }}</div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/header.vue'
import {request} from '@/api/request'
import Utils from '@/utils/formatUnit'
import rate from '@/filters/rate'
export default {
  name: 'StockRzrqList',
  data() {
    return {
      innerCode: '',
      stockName: '',
      list: [],
      dateList: []
    }
  },
  components: {
    Header
  },
  filters: {
    formatUnit: Utils.formatUnit,
    rate,
    formatDate: function(val) {
      return val.substring(0, 10).replace(/-/g,'/')
    }
  },
  methods: {
    formatUnit(val) {
      if(!val) return '--'
      return Utils.formatUnit(val)
    },
    handleUrlParams(){
      let { name ,innerCode }  = this.$route.query
      return {
        stockName: name,
        innerCode
      }
    },
    connectHeadScroll() {
      // if(this.timer) clearTimeout(this.timer)
      // this.timer = setTimeout(() => {
      //   this.scolling = false
      // }, 500);
      // this.scolling = true
      this.$refs.headnoscroll.scrollLeft = this.$refs.datalist.scrollLeft
    },
    sliceTimeCloumn(list) {
      return list.map((o)=>{
        return o.TradingDay.substring(0, 10).replace(/-/g,'/')
      })
    },
    async getList() {
      const res = await request.get({
        url: request.apis.quote.query2TradingDetailTable,
        params: {pageSize:100, InnerCode: this.innerCode}
      })
      this.list = res || []
      this.dateList = this.sliceTimeCloumn(this.list)
    },
  },
  created() {
    let { stockName, innerCode }  = this.handleUrlParams()
    this.stockName = stockName
    this.innerCode = innerCode
    this.getList()
  }
}
</script>
<style lang="stylus" scoped>
  .head
    font-weight 500
    /deep/ p 
      font-size .17rem
  .wrap
    // padding 40px 0 0
    background-color #fff
  .list-container
    padding 0 0 0 0.12rem
    margin-top 40px
    background #ffffff
    height calc(100vh - .4rem)
    overflow hidden
    .head
      height .3rem
      display flex
      font-weight 400
      line-height .18rem
      white-space nowrap
  .headList
    overflow visible
    flex-shrink 0
  .dataList
    width calc(100vw - 1.4rem)
    overflow-x auto
    overflow-y visible
    -webkit-overflow-scrolling touch
    &::-webkit-scrollbar
      display none
  .list
    display flex
    height calc(100% - .3rem)
    overflow-y auto
    overflow-x hidden
    -webkit-overflow-scrolling touch
    &::-webkit-scrollbar
      display none
  .xv-symbol
    width 1.4rem
    text-align left
    align-items center
    flex-shrink 0
    display flex
    position relative
    &:after
      content: ''
      width 0.32rem
      height 100%
      position absolute
      right -.17rem
      top 0
      background linear-gradient(270deg,rgba(238,238,238,0) 0%,rgba(216,216,216,0.5) 100%)
  .j
    width 0.75rem
    font-family DINAlternate-Bold,DINAlternate
    text-align right
  .zf
    width 0.75rem
    font-family DINAlternate-Bold,DINAlternate
    line-height .15rem
    text-align right
  .buy
    width .9rem
  .rzche
    width .9rem
  .rzjme
    width .95rem
  .rzye
    width .84rem
  .rzyezlb
    width 1.21rem
  .rzmcl
    width .95rem
  .rzchl
    width .95rem
  .rzjml
    width .95rem
  .rqyl
    width .95rem
  .rqye
    width .84rem
  .lrye
    width .84rem
  .lryecz
    width 1.2rem
    padding-right .24rem
    box-sizing border-box
  .align-left
    display flex
    flex-shrink 0
    justify-content flex-end
    align-items center
  .headItem
    .symbol-item
      background #ffffff
      height .35rem
      will-change transform
      font-size 14px
      color #333
  .dataItem
    display flex
    height .35rem
    font-size 15px
    font-weight bold
    .money
      font-family DINAlternate-Bold,DINAlternate
      font-weight bold
      color #333333
    .red
      color #F43737
    .green
      color #1BAA3C
    .black
      color #333333
  .headnoscroll
    display flex
    width calc(100vw - 1.5rem)
    overflow-x hidden
    color #999
    -webkit-overflow-scrolling touch
    &::-webkit-scrollbar
      display none
</style>